module.exports = __webpack_public_path__ + "assets/img/template-introduce-list-2.98c83288.png";